import {ApiOperationsType} from './Api.types';

export enum RestApiMethod {
  GET,
}

export enum ApiOperation {
  SearchDocuments,
  GetDocument,
}

export const Operations: ApiOperationsType = {
  [ApiOperation.SearchDocuments]: {
    method: RestApiMethod.GET,
    url: ({text}) => `/Document/search/${text}`,
  },
  [ApiOperation.GetDocument]: {
    method: RestApiMethod.GET,
    url: () => '/Document',
    responseType: 'blob'
  }
};
